import moneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";
import { connect } from "react-redux";
export default connect((state) => {
  const { forecastTooltip = "" } = state.revenue || "";
  return {
    value: state.revenue.allRevenues.forecast,
    color: "#92bef4",
    currency: state.revenue.allRevenues.currencySymbol,
    size: 44,
    disableAnimation: state.revenue.currentUser.qa,
    toolTip: forecastTooltip,
    toolTipId: "revenueDetailsForecast"
  };
})(moneyDisplay);
